export default __webpack_public_path__ + "static/media/item1.1c214071.png";